"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var withSitecoreContext_1 = require("../enhancers/withSitecoreContext");

var emittedVI = false;

var VIComponent = function VIComponent(_a) {
  var sitecoreContext = _a.sitecoreContext;

  if (emittedVI || typeof document === 'undefined' || !sitecoreContext.visitorIdentificationTimestamp) {
    // Don't emit VI script and meta tag if we've already done so,
    // aren't rendering client-side, or don't have a VI timestamp.
    return null;
  }

  emittedVI = true;
  var script = document.createElement('script');
  script.src = "/layouts/system/VisitorIdentification.js";
  script.type = 'text/javascript';
  var meta = document.createElement('meta');
  meta.name = 'VIcurrentDateTime';
  meta.content = sitecoreContext.visitorIdentificationTimestamp;
  var head = document.querySelector('head');
  head && head.appendChild(script);
  head && head.appendChild(meta);
  return null;
};

VIComponent.displayName = 'VisitorIdentification';
exports.VisitorIdentification = withSitecoreContext_1.withSitecoreContext()(VIComponent);